export const dataCard = [
  {
    discount: '25%',
    hitSales: true,
    brand: 'Nike',
    description:
      'Мужские кроссовки Nike Air Max 270 React в стильном дизайне Мужские кроссовки Nike Air Max 270 React в стильном дизайне',
    price: 12999,
    pastPrice: 15999,
    inStock: true,
  },
  {
    discount: '15%',
    hitSales: false,
    brand: 'Adidas',
    description: 'Женские кроссовки Adidas Ultraboost 21 для бега и фитнеса',
    price: 14999,
    pastPrice: 17599,
    inStock: true,
  },
  {
    discount: '30%',
    hitSales: true,
    brand: 'Puma',
    description: 'Детские кроссовки Puma RS-X³ Puzzle с яркими цветовыми акцентами',
    price: 5999,
    pastPrice: 8599,
    inStock: true,
  },
  {
    discount: '20%',
    hitSales: false,
    brand: 'Reebok',
    description: 'Мужские кроссовки Reebok Classic Leather в винтажном стиле',
    price: 6999,
    pastPrice: 8799,
    inStock: true,
  },
  {
    discount: '10%',
    hitSales: true,
    brand: 'New Balance',
    description: 'Женские кроссовки New Balance 574 в ретро-стиле',
    price: 8999,
    pastPrice: 9999,
    inStock: true,
  },
  {
    discount: '40%',
    hitSales: true,
    brand: 'Asics',
    description: 'Мужские кроссовки Asics Gel-Nimbus 23 для длительных пробежек',
    price: 11999,
    pastPrice: 19999,
    inStock: false,
  },
  {
    discount: '5%',
    hitSales: false,
    brand: 'Converse',
    description: 'Высокие кеды Converse Chuck Taylor All Star в классическом дизайне',
    price: 5699,
    pastPrice: 5999,
    inStock: true,
  },
  {
    discount: '35%',
    hitSales: true,
    brand: 'Vans',
    description: 'Слипоны Vans Classic Slip-On с принтом в шахматную клетку',
    price: 4599,
    pastPrice: 6999,
    inStock: true,
  },
  {
    discount: '15%',
    hitSales: false,
    brand: 'Under Armour',
    description: 'Мужские кроссовки Under Armour HOVR Phantom 2 для бега',
    price: 13599,
    pastPrice: 15999,
    inStock: true,
  },
  {
    discount: '25%',
    hitSales: true,
    brand: 'Skechers',
    description: "Женские кроссовки Skechers D'Lites с массивной подошвой",
    price: 5999,
    pastPrice: 7999,
    inStock: true,
  },
  {
    discount: '20%',
    hitSales: false,
    brand: 'Fila',
    description: 'Мужские кроссовки Fila Disruptor II в стиле 90-х',
    price: 7199,
    pastPrice: 8999,
    inStock: true,
  },
  {
    discount: '30%',
    hitSales: true,
    brand: 'Mizuno',
    description: 'Беговые кроссовки Mizuno Wave Rider 24 с амортизацией',
    price: 10499,
    pastPrice: 14999,
    inStock: false,
  },
  {
    discount: '10%',
    hitSales: false,
    brand: 'Salomon',
    description: 'Трейловые кроссовки Salomon Speedcross 5 для бездорожья',
    price: 11699,
    pastPrice: 12999,
    inStock: true,
  },
  {
    discount: '40%',
    hitSales: true,
    brand: 'Brooks',
    description: 'Женские кроссовки Brooks Ghost 13 для ежедневных пробежек',
    price: 8999,
    pastPrice: 14999,
    inStock: true,
  },
  {
    discount: '5%',
    hitSales: false,
    brand: 'Merrell',
    description: 'Треккинговые ботинки Merrell Moab 2 для походов',
    price: 9499,
    pastPrice: 9999,
    inStock: true,
  },
  {
    discount: '25%',
    hitSales: true,
    brand: 'Onitsuka Tiger',
    description: 'Кроссовки Onitsuka Tiger Mexico 66 в винтажном стиле',
    price: 7499,
    pastPrice: 9999,
    inStock: true,
  },
  {
    discount: '15%',
    hitSales: false,
    brand: 'Hoka One One',
    description: 'Беговые кроссовки Hoka One One Clifton 7 с максимальной амортизацией',
    price: 11899,
    pastPrice: 13999,
    inStock: true,
  },
  {
    discount: '20%',
    hitSales: true,
    brand: 'Columbia',
    description: 'Водонепроницаемые ботинки Columbia Newton Ridge Plus II для трекинга',
    price: 7999,
    pastPrice: 9999,
    inStock: false,
  },
  {
    discount: '30%',
    hitSales: false,
    brand: 'Timberland',
    description: 'Классические ботинки Timberland 6-Inch Premium Waterproof',
    price: 13999,
    pastPrice: 19999,
    inStock: true,
  },
  {
    discount: '10%',
    hitSales: true,
    brand: 'Dr. Martens',
    description: 'Ботинки Dr. Martens 1460 8-Eye Boot в классическом дизайне',
    price: 14399,
    pastPrice: 15999,
    inStock: true,
  },
];
